@file:OptIn(InternalResourceApi::class)

package resursedeblocat.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/resursedeblocat.composeapp.generated.resources/"

@delegate:ResourceContentHash(747_143_258)
internal val Res.string.tracking_theory_example2: StringResource by lazy {
      StringResource("string:tracking_theory_example2", "tracking_theory_example2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6821, 64),
      ))
    }

@delegate:ResourceContentHash(-447_744_003)
internal val Res.string.tracking_theory_example3: StringResource by lazy {
      StringResource("string:tracking_theory_example3", "tracking_theory_example3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6886, 88),
      ))
    }

@delegate:ResourceContentHash(-391_724_926)
internal val Res.string.tracking_theory_example4: StringResource by lazy {
      StringResource("string:tracking_theory_example4", "tracking_theory_example4", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6975, 68),
      ))
    }

@delegate:ResourceContentHash(1_678_541_976)
internal val Res.string.tracking_theory_subtitle: StringResource by lazy {
      StringResource("string:tracking_theory_subtitle", "tracking_theory_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7044, 176),
      ))
    }

@delegate:ResourceContentHash(-342_178_556)
internal val Res.string.tracking_theory_title: StringResource by lazy {
      StringResource("string:tracking_theory_title", "tracking_theory_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7221, 53),
      ))
    }

@delegate:ResourceContentHash(339_202_675)
internal val Res.string.tracking_weekly_income_subtitle: StringResource by lazy {
      StringResource("string:tracking_weekly_income_subtitle", "tracking_weekly_income_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7275, 127),
      ))
    }

@delegate:ResourceContentHash(-873_338_585)
internal val Res.string.tracking_weekly_income_title: StringResource by lazy {
      StringResource("string:tracking_weekly_income_title", "tracking_weekly_income_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7403, 104),
      ))
    }

@delegate:ResourceContentHash(-482_593_749)
internal val Res.string.tracking_well_being_subtitle: StringResource by lazy {
      StringResource("string:tracking_well_being_subtitle", "tracking_well_being_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7508, 108),
      ))
    }

@delegate:ResourceContentHash(1_966_747_776)
internal val Res.string.tracking_well_being_title: StringResource by lazy {
      StringResource("string:tracking_well_being_title", "tracking_well_being_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7617, 69),
      ))
    }

@delegate:ResourceContentHash(-1_945_576_388)
internal val Res.string.tracking_work_hours_subtitle: StringResource by lazy {
      StringResource("string:tracking_work_hours_subtitle", "tracking_work_hours_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7687, 164),
      ))
    }

@delegate:ResourceContentHash(350_198_536)
internal val Res.string.tracking_work_hours_title: StringResource by lazy {
      StringResource("string:tracking_work_hours_title", "tracking_work_hours_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7852, 113),
      ))
    }

@delegate:ResourceContentHash(2_513_293)
internal val Res.string.tracking_yes: StringResource by lazy {
      StringResource("string:tracking_yes", "tracking_yes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7966, 24),
      ))
    }

@delegate:ResourceContentHash(-653_372_051)
internal val Res.string.usage_suggestions: StringResource by lazy {
      StringResource("string:usage_suggestions", "usage_suggestions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7991, 57),
      ))
    }

@delegate:ResourceContentHash(-129_345_211)
internal val Res.string.welcome_subtitle: StringResource by lazy {
      StringResource("string:welcome_subtitle", "welcome_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8049, 108),
      ))
    }

@delegate:ResourceContentHash(-1_098_386_874)
internal val Res.string.welcome_title: StringResource by lazy {
      StringResource("string:welcome_title", "welcome_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8158, 61),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("tracking_theory_example2", Res.string.tracking_theory_example2)
  map.put("tracking_theory_example3", Res.string.tracking_theory_example3)
  map.put("tracking_theory_example4", Res.string.tracking_theory_example4)
  map.put("tracking_theory_subtitle", Res.string.tracking_theory_subtitle)
  map.put("tracking_theory_title", Res.string.tracking_theory_title)
  map.put("tracking_weekly_income_subtitle", Res.string.tracking_weekly_income_subtitle)
  map.put("tracking_weekly_income_title", Res.string.tracking_weekly_income_title)
  map.put("tracking_well_being_subtitle", Res.string.tracking_well_being_subtitle)
  map.put("tracking_well_being_title", Res.string.tracking_well_being_title)
  map.put("tracking_work_hours_subtitle", Res.string.tracking_work_hours_subtitle)
  map.put("tracking_work_hours_title", Res.string.tracking_work_hours_title)
  map.put("tracking_yes", Res.string.tracking_yes)
  map.put("usage_suggestions", Res.string.usage_suggestions)
  map.put("welcome_subtitle", Res.string.welcome_subtitle)
  map.put("welcome_title", Res.string.welcome_title)
}
